// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__WV7An","infiniteLoader":"loader_infiniteLoader__FUEOJ"};